import { render, staticRenderFns } from "./ViewUserRolesAndExceptions.vue?vue&type=template&id=60d3c855&scoped=true&"
import script from "./ViewUserRolesAndExceptions.vue?vue&type=script&lang=ts&"
export * from "./ViewUserRolesAndExceptions.vue?vue&type=script&lang=ts&"
import style0 from "./ViewUserRolesAndExceptions.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./ViewUserRolesAndExceptions.vue?vue&type=style&index=1&id=60d3c855&scoped=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "60d3c855",
  null
  
)

export default component.exports